import e from"react";import{ModalCloseButton as t}from"./ModalCloseButton.js";import{Header as l,Title as r}from"../styles.js";const m=({children:m,className:o})=>e.createElement(l,{className:o},e.createElement(r,null,m),e.createElement(t,null));export{m as ModalHeader};
//# sourceMappingURL=ModalHeader.js.map
